import React, { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { Bars3CenterLeftIcon } from '@heroicons/react/24/outline';
import { AuthEventData } from '@aws-amplify/ui';
import cx from 'classnames';

function StickyHeader({
  nameInitial,
  setSidebarOpen,
  signOut
}: {
  nameInitial: string;
  setSidebarOpen: (value: boolean) => void;
  signOut: ((data?: AuthEventData | undefined) => void) | undefined;
}): JSX.Element {
  return (
    <div className="sticky top-0 z-10 flex h-16 flex-shrink-0 border-b border-gray-200 bg-white lg:hidden">
      <button
        type="button"
        className="border-r border-gray-200 px-4 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-purple-500 lg:hidden"
        onClick={() => setSidebarOpen(true)}>
        <span className="sr-only">Open sidebar</span>
        <Bars3CenterLeftIcon className="h-6 w-6" aria-hidden="true" />
      </button>
      <div className="flex flex-1 justify-end items-center px-4 sm:px-6 lg:px-8">
        <Menu as="div" className="relative ml-3">
          <div>
            <Menu.Button className="flex max-w-xs items-center rounded-full bg-white text-sm focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2">
              <div className="h-10 w-10 flex-shrink-0 rounded-full bg-gray-600 flex items-center justify-center text-sm text-white">
                {nameInitial}
              </div>
            </Menu.Button>
          </div>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95">
            <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right divide-y divide-gray-200 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
              <div className="py-1">
                <Menu.Item>
                  {({ active }) => (
                    <a
                      className={cx('block px-4 py-2 text-sm cursor-pointer', {
                        'bg-gray-100 text-gray-900': active,
                        'text-gray-700': !active
                      })}
                      onClick={signOut}>
                      Sign out
                    </a>
                  )}
                </Menu.Item>
              </div>
            </Menu.Items>
          </Transition>
        </Menu>
      </div>
    </div>
  );
}

export default StickyHeader;
